import { Link } from "react-router-dom";
import { T } from "@/constants/testIds";

export default function HindiContent() {
  return (
    <section data-testid={T.hindiContent} className="py-20 sm:py-28">
      <div className="container-editorial grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-5">
          <span className="eyebrow text-terracotta">भारतीय पाठकों के लिए · For Indian readers</span>
          <h2 className="heading-2 mt-3 font-hindi text-ink" style={{ fontWeight: 500 }}>
            अनन्त जीवन <em className="italic text-forest">यीशु मसीह में</em>
          </h2>
          <p className="body-copy mt-6 text-ink-muted font-hindi leading-relaxed">
            परमेश्वर सब लोगों को अपने प्रेम में बुला रहे हैं। यीशु मसीह के द्वारा पाप की क्षमा, नया जीवन, और
            परमेश्वर के साथ अनन्त संगति उपलब्ध है — मुफ्त, अनुग्रह से।
          </p>
          <p className="text-sm mt-4 text-ink-muted">
            Anant Jeevan is being translated with theological review into Hindi and other Indian languages. If a page
            is not yet translated, we will show the English version and let you know it is in progress.
          </p>
          <div className="mt-8">
            <Link to="/languages" className="btn-ghost">
              Read in Hindi · हिन्दी में पढ़ें
            </Link>
          </div>
        </div>

        <div className="md:col-span-7">
          <div className="paper-card p-8 sm:p-10 relative">
            <p className="eyebrow">यूहन्ना 3:16</p>
            <p className="font-hindi text-2xl sm:text-3xl mt-4 text-ink leading-snug" style={{ fontWeight: 500 }}>
              क्योंकि परमेश्वर ने जगत से ऐसा प्रेम रखा कि उसने अपना एकलौता पुत्र दे दिया, ताकि जो कोई उस पर विश्वास करे,
              वह नाश न हो, परन्तु अनन्त जीवन पाए।
            </p>
            <p className="text-xs text-ink-muted mt-5">Bible passage shown in Hindi — public domain rendering.</p>

            <div className="mt-8 pt-6 border-t border-border grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div>
                <p className="eyebrow">Languages ready</p>
                <p className="mt-2 text-sm text-ink-soft">English</p>
              </div>
              <div>
                <p className="eyebrow">In translation</p>
                <p className="mt-2 text-sm text-ink-soft">हिन्दी, ଓଡ଼ିଆ, മലയാളം, తెలుగు, ಕನ್ನಡ, தமிழ், छत्तीसगढ़ी</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
